import React from 'react'

import { ModifierOptionQuantitySelector } from './ModifierOptionQuantitySelector/ModifierOptionQuantitySelector'
import { ModifierOptionToggleSelector } from './ModifierOptionToggleSelector/ModifierOptionToggleSelector'

export const ModifierOptionSelector = React.memo(({ modifier, option, ...props }) => {
  const Component = modifier.supportsChoiceQuantities ? ModifierOptionQuantitySelector : ModifierOptionToggleSelector
  return <Component modifier={modifier} option={option} {...props} />
})
